<template>
  <div>
    <template v-if="!isEdit">
      <template v-if="filter == 'decimal'">
        <span :title="text">{{ text | decimalFormat }}</span>
      </template>
      <template v-else-if="filter == 'image'">
        <template v-if="text">
          <div style=" line-height: 0" class="text-xs-center">
            <img
              :src="urlify(text)"
              :alt="text"
              :title="text"
              style="width:100%;word-wrap: break-word;cursor: pointer; max-width: 600px;"
              v-if="urlify(text)"
              @click="isShow = true"
            />
            <preview-image @close="isShow = false" v-model="isShow">
              <img :src="urlify(text)" slot="body" :alt="text" v-if="text" style="width: 100%" />
            </preview-image>
          </div>
        </template>
      </template>
      <template v-else>
        <nl2br
          v-if="text"
          tag="span"
          :text="type === 'date' ? dateFomat : text"
          :title="text"
          style="word-wrap: break-word;"
        />
      </template>
      <template v-if="filter != 'image'">
        <div style="display: inline-block">
          <v-btn flat fab small color="primary" class="ma-0" @click="onEdit">
            <v-icon>edit</v-icon>
          </v-btn>
          <template v-if="hasCopy">
            <v-tooltip v-model="showCopy" bottom color="success">
              <template v-slot:activator="{}">
                <v-btn
                  flat
                  fab
                  small
                  class="ma-0"
                  color="primary"
                  v-clipboard:copy="text"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onCopyError"
                >
                  <v-icon>file_copy</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('Copied') }}</span>
            </v-tooltip>
          </template>
        </div>
        <!-- <a href="javascript:void(0);" class="small" @click="onEdit">
          <span class="fa fa-pencil-alt"></span>
        </a>-->
      </template>
    </template>
    <template v-else>
      <template v-if="type == 'textarea'">
        <div class="form-control">
          <textarea
            @keyup.enter="saveChange"
            rows="3"
            v-model="text"
            style="resize: vertical"
          ></textarea>

          <div class="text-xs-center">
            <v-btn outline small color="primary" class="" @click="cancelChange">
              {{ $t('cancel') }}
            </v-btn>

            <v-btn outline small depressed color="primary" @click="saveChange">
              {{ $t('Save') }}
            </v-btn>
          </div>
        </div>
      </template>
      <template v-else-if="type == 'image'">
        <!-- <img :src="text" :alt="text" :title="text"> -->
      </template>
      <template v-else-if="type == 'date'">
        <div>
          <date-picker color="primary" v-model="text">
            <template v-slot="{ computedDate }">
              <v-text-field
                dense
                :data-vv-as="$t('from')"
                :value="computedDate"
                readonly
                placeholder="DD/MM/YYYY"
                hide-details
                outline
                single-line
                label=""
              ></v-text-field>
            </template>
          </date-picker>

          <div class="text-xs-center">
            <v-btn outline small color="primary" class="" @click="cancelChange">
              {{ $t('cancel') }}
            </v-btn>

            <v-btn outline small depressed color="primary" @click="saveChange">
              {{ $t('Save') }}
            </v-btn>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="form-control">
          <input
            @keyup.enter="saveChange"
            type="text"
            v-model="text"
            class="form-control"
            :maxlength="maxLengthRemark"
          />

          <div class="text-xs-center">
            <v-btn outline small color="primary" class="" @click="cancelChange">
              {{ $t('cancel') }}
            </v-btn>
            <v-btn depressed small color="primary" class="" @click="saveChange">
              {{ $t('Save') }}
            </v-btn>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import DatePicker from '@/components/elements/DatePicker.vue'
import PreviewImage from '@/components/elements/PreviewImage'
import Nl2br from 'vue-nl2br'
import dayjs from 'dayjs'
import { cloneDeep } from 'lodash'
export default {
  props: ['value', 'type', 'filter', 'hasCopy', 'maxLengthRemark'],
  data: function() {
    return {
      text: this.value,
      isEdit: false,
      isShow: false,
      showCopy: false
    }
  },
  computed: {
    dateFomat() {
      if (this.type === 'date') {
        return dayjs(this.value).format('DD/MM/YYYY')
      }
    }
  },
  components: {
    DatePicker,
    PreviewImage,
    Nl2br
  },
  methods: {
    onEdit() {
      this.isEdit = true
      this.cached_text = cloneDeep(this.text)
    },
    onCopy() {
      let vm = this

      vm.showCopy = true
      setTimeout(() => {
        vm.showCopy = false
      }, 3000)
    },
    onCopyError() {},
    saveChange: function() {
      this.isEdit = false
      this.cached_text = cloneDeep(this.text)
      this.$emit('input', this.text)
      this.$emit('edited')
    },
    cancelChange: function() {
      this.isEdit = false
      this.text = cloneDeep(this.cached_text)
      this.$emit('input', this.text)
      this.$emit('edited')
    },
    urlify: function(text) {
      if (!text.startsWith('data:image')) {
        var urlRegex = /(https?:\/\/[^\s]+)/g
        if (text.match(urlRegex) && text.match(urlRegex).length > 0) {
          return text.match(urlRegex)[0]
        }
        return null
      } else {
        return text
      }
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      if (newVal != oldVal) {
        this.text = this.value
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/elements/Editable.vue